/**
 * Web upsell links: subscriptions run through the native apps (RevenueCat).
 * Override with env when App Store / Play listings are final.
 */
export function getSubscribeStoreUrls() {
  return {
    ios:
      process.env.REACT_APP_IOS_APP_STORE_URL ||
      process.env.REACT_APP_APP_STORE_URL ||
      'https://padelmvp.co.uk/',
    android:
      process.env.REACT_APP_ANDROID_PLAY_STORE_URL ||
      process.env.REACT_APP_PLAY_STORE_URL ||
      'https://play.google.com/store/apps/details?id=uk.co.padelmvp.app',
  };
}
